@if (shouldShowBanner$ | ngrxPush) {
  @if (data$ | async; as data) {
    <!-- NOTE: 30 <= daysTillRenewal > 7 -->
    @if (show30DayBanner$ | ngrxPush) {
      <div class="renewal-reminder-container white-text status" role="status">
        <div class="left">
          <terra-icon icon="info-circle" variant="regular"></terra-icon>
        </div>

        <div class="center">
          <div class="header">
            Your {{ data.subscriptionName }} plan renews on {{ data.renewalDate | date: 'MMM. d, y' }}
          </div>

          <div class="subheader">Review your plan and licenses before it renews.</div>

          <div class="footer">
            <a
              aria-label="Manage billing"
              class="cta white-text"
              [routerLink]="['/settings/billing/overview']"
              (click)="reviewBilling(intervals.ThirtyDays, data.renewalDate)">
              Manage Billing
            </a>
          </div>
        </div>

        <div class="right">
          <div>
            <ninety-button
              flat
              secondary
              icon
              aria-label="Dismiss subscription renewal notification"
              (click)="dismissRenewalNotification(intervals.ThirtyDays, data.renewalDate)">
              <terra-icon class="white-text" icon="x" />
            </ninety-button>
          </div>
        </div>
      </div>
    }

    <!-- NOTE: 7 <= daysTillRenewal > 0 -->
    @if (show7DayBanner$ | ngrxPush) {
      <div class="renewal-reminder-container black-text alert" role="alert">
        <div class="left">
          <terra-icon icon="clock"></terra-icon>
        </div>

        <div class="center">
          <div class="header">
            Your {{ data.subscriptionName }} plan renews on {{ data.renewalDate | date: 'MMM. d, y' }}
          </div>

          <div class="subheader">Review your current plan and license count today.</div>

          <div class="footer">
            <a
              aria-label="Manage billing"
              class="cta black-text"
              [routerLink]="['/settings/billing/overview']"
              (click)="reviewBilling(intervals.SevenDays, data.renewalDate)">
              Manage Billing
            </a>
          </div>
        </div>

        <div class="right">
          <div>
            <ninety-button
              flat
              secondary
              icon
              aria-label="Dismiss subscription renewal notification"
              (click)="dismissRenewalNotification(intervals.SevenDays, data.renewalDate)">
              <terra-icon class="black-text" icon="x" />
            </ninety-button>
          </div>
        </div>
      </div>
    }
  }
}
